(() => {
  const page = document.querySelector('[data-evolene-listicle]');
  if (!page) return;

  document.documentElement.classList.add('evl5-is-open');
  document.body.classList.add('evl5-is-open');

  const productUrl = page.dataset.productUrl || '/products/serum';
  const incoming = new URLSearchParams(window.location.search);

  page.querySelectorAll('[data-evl5-cta]').forEach((link) => {
    const destination = new URL(productUrl, window.location.origin);
    incoming.forEach((value, key) => {
      if (!destination.searchParams.has(key)) destination.searchParams.set(key, value);
    });
    destination.searchParams.set('source', 'listicle-5');
    link.href = destination.toString();
  });

  const sticky = page.querySelector('[data-evl5-sticky]');
  const hero = page.querySelector('[data-evl5-hero]');
  const closing = page.querySelector('.evl5__closing');

  const update = () => {
    if (!sticky || !hero) return;
    const closingIsVisible = closing && closing.getBoundingClientRect().top < page.clientHeight - 40;
    sticky.classList.toggle('is-visible', page.scrollTop > hero.offsetHeight && !closingIsVisible);
  };

  page.addEventListener('scroll', update, { passive: true });
  update();
})();
